import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
////// Mui
import { Grid, LinearProgress } from "@mui/material";
// Controls & Components
import { baseURL } from "../Data/baseURL";
import FileHeader from "./FileHeader";
import axiosInstance from "../../services/axios/axios";

const SingleFileUploadWithProgress = React.memo(
  ({ file, onDelete, onUpload }) => {
    const location = useLocation();
    const [progress, setProgress] = useState(0);

    useEffect(() => {
      async function upload() {
        const resp = await uploadFile(file, setProgress);

        resp && onUpload(file, resp);
      }
      upload();
    }, [onUpload, file]);

    return (
      <Grid item xs={12}>
        {location.pathname !== "/apps/account" ? (
          <>
            <FileHeader file={file} onDelete={onDelete} />
            <LinearProgress variant='determinate' value={progress} />
          </>
        ) : null}
      </Grid>
    );
  }
);

export default SingleFileUploadWithProgress;

function uploadFile(file, onProgress) {
  const url = `${baseURL}/app/image/`;
  const formData = new FormData();

  formData.append("file_name", file);

  return axiosInstance({
    url: url,
    method: "POST",
    data: formData,
    onUploadProgress: (progressEvent) => {
      if (progressEvent.lengthComputable) {
        const percentage = (progressEvent.loaded / progressEvent.total) * 100;
        onProgress(Math.round(percentage));
      }
    },
    // headers: {
    //   "content-type": "multipart/form-data",
    // },
  })
    .then((response) => {
      if (response) return response.data;
    })
    .catch(() => {}, []);
}

// // DO NOT TOUCH
// function uploadFile(file, onProgress) {
//   const url = `${baseURL}app/image/`;
//   return new Promise((res, rej) => {
//     const xhr = new XMLHttpRequest();
//     xhr.open("POST", url);
//     xhr.onload = () => {
//       const resp = JSON.parse(xhr.responseText);
//       res(resp);
//     };
//     xhr.onerror = (evt) => rej(evt);
//     xhr.upload.onprogress = (evt) => {
//       if (evt.lengthComputable) {
//         const percentage = (evt.loaded / evt.total) * 100;
//         onProgress(Math.round(percentage));
//       }
//     };
//     const formData = new FormData();

//     formData.append("id", "");
//     formData.append("category", "CMR");
//     formData.append("file_name", file);
//     xhr.send(formData);
//   });
// }
